import type { Ref } from 'vue'
import { useSegmentProductAnalytics } from '@/views/product/composables/analytics/useSegmentProductAnalytics'
import type { ProductAnalyticsFragment } from '@/graphql/api'
import type { RingBuilder } from '@/plugins/ring-builder.ts'
import { useSegment } from '@/third-party/segment.ts'

interface HandleAddToCartSuccess {
    prepare(): () => void
}

export function useHandleAddToCartSuccess(
    ring: Readonly<Ref<ProductAnalyticsFragment | undefined | null>>,
    ringBuilder?: Readonly<Ref<RingBuilder | undefined>>
): HandleAddToCartSuccess {
    const { track } = useSegment()
    const serialize = useSegmentProductAnalytics()

    // TODO check if should redirect to design studio

    // Prepare fn - saves snapshot from data so it won't change later. (Mutations from API changes the data)
    const prepare = () => {
        const ringValue = ring.value
        const ringBuilderValue = ringBuilder?.value

        const serialized = ringValue
            ? serialize(ringValue, ringBuilderValue)
            : null

        return () => {
            if (serialized) {
                track('Product Added', serialized)
            }
        }
    }

    return { prepare }
}
